/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class UserCustomState {
    //0，未设置，1 忙碌，2 离开（主动设置），3 离开（长时间不操作），4 隐身，其它可以自主扩展。
    state;
    text;
}
